import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link, useMatch } from 'react-router';
import { Nav, NavItem, NavLink } from 'react-bootstrap';
import { useMediaBreakpoint } from 'components/hooks/media/useMediaBreakpoint';
import { useLoggerTracking } from 'components/hooks/logger/useLoggerTracking';
import { TrackedFeature, TrackedPage, TRACKING_PARAM_KEYS } from 'services/Logger';
import { RoutePaths } from 'routes/RoutePaths';

export const ServiceboardHeaderMenuNavbar: React.FC = () => {
    const { t: translate } = useTranslation('catalog');
    const mediaBreakpoint = useMediaBreakpoint();
    const track = useLoggerTracking();
    const active = useMatch(RoutePaths.Catalog.route + '/*')
        ? 'catalog'
        : 'myservices';

    const navClassName = {
        'navbar-menu-dropdown flex-column d-flex': ['xs', 'sm'].includes(mediaBreakpoint),
    };

    return <Nav className={classNames('flex-nowrap ms-auto gap-0', navClassName)}>
        <NavItem>
            <NavLink
                className={
                    classNames('navbar-link ', { active: active === 'catalog' },
                    )}
                aria-current="page"
                as={Link}
                to={RoutePaths.Catalog.Browse.url()}
                onClick={() => track(TrackedPage.CatalogBrowse, TrackedFeature.OpenService, { [TRACKING_PARAM_KEYS.page]: window.location.pathname })}
            >
                {translate('catalog:catalog')}
            </NavLink>
        </NavItem>
        <NavItem>
            <NavLink
                className={classNames('navbar-link ', { active: active === 'myservices' })}
                aria-current="page"
                as={Link}
                to={RoutePaths.MyServices.url()}
                onClick={() => track(TrackedPage.Essentials, TrackedFeature.OpenService, { [TRACKING_PARAM_KEYS.page]: window.location.pathname })}
            >
                {translate('catalog:myServices')}
            </NavLink>
        </NavItem>
    </Nav>;
};
